import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing';
import PricingPage from './pages/pricing';
import LoginPage from './pages/login';
import SignupPage from './pages/signup';
import SubscriptionConfirmedPage from './pages/subscription-confirmed';
import MySubscriptionPage from './pages/my-subscription';
import CSVImportDashboard from './pages/csv-import-dashboard';
import ProductCatalogManager from './pages/product-catalog-manager';
import DashboardOverview from './pages/dashboard-overview';
import EcommerceHub from './pages/ecommerce-hub';
import AIApiConfigurationCenter from './pages/ai-api-configuration-center';
import AIAssistantHub from './pages/ai-assistant-hub';
import AIInsights from './pages/ai-insights';
import RealTimeMonitoringDashboard from './pages/real-time-monitoring-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/subscription-confirmed" element={<SubscriptionConfirmedPage />} />
        
        {/* Protected Routes */}
        <Route path="/my-subscription" element={<MySubscriptionPage />} />
        <Route path="/dashboard-overview" element={<DashboardOverview />} />
        <Route path="/csv-import-dashboard" element={<CSVImportDashboard />} />
        <Route path="/product-catalog-manager" element={<ProductCatalogManager />} />
        <Route path="/ecommerce-hub" element={<EcommerceHub />} />
        <Route path="/ai-api-configuration-center" element={<AIApiConfigurationCenter />} />
        <Route path="/ai-assistant-hub" element={<AIAssistantHub />} />
        <Route path="/ai-insights" element={<AIInsights />} />
        <Route path="/real-time-monitoring-dashboard" element={<RealTimeMonitoringDashboard />} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
